/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * F032 step 9: My training. Members' Home and staff's own training page:
 * Overview and Records, as the app shows them. No page heading (D10).
 */
import React from "react";
import { useSearchParams } from "react-router-dom";
import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from "@lemonadetraining/web-ui";
import { IconPlus } from "@tabler/icons-react";
import { LINE_TAB_TRIGGER, LINE_TABS_LIST } from "../../lib/lineTabs";
import TrainingOverview from "../../components/training/TrainingOverview";
import RecordsTab from "../../components/training/RecordsTab";
import { openMovementSearch } from "../../components/movement/movementSearchEvents";
import { useTrainingRegistry } from "../../hooks/useTrainingRegistry";
import { useMovementStateFromContext } from "../../contexts/MovementStateContext";

type TrainingTab = "overview" | "records";

export default function MyTrainingPage() {
  const [params, setParams] = useSearchParams();
  const tab: TrainingTab = params.get("tab") === "records" ? "records" : "overview";
  const registry = useTrainingRegistry();
  const movementState = useMovementStateFromContext();

  return (
    <Tabs
      value={tab}
      onValueChange={(next) => {
        const p = new URLSearchParams();
        if (next === "records") p.set("tab", "records");
        setParams(p);
      }}
      className="gap-4"
      data-testid="my-training-page"
    >
      <h1 className="sr-only">My training</h1>
      <div className="flex items-end gap-2 border-b">
        <TabsList variant="line" className={LINE_TABS_LIST} aria-label="My training">
          <TabsTrigger value="overview" className={LINE_TAB_TRIGGER}>
            Overview
          </TabsTrigger>
          <TabsTrigger value="records" className={LINE_TAB_TRIGGER}>
            Records
          </TabsTrigger>
        </TabsList>
        {tab === "overview" && (
          <Button
            className="mb-1.5 ml-auto"
            onClick={() => openMovementSearch({ log: true })}
            title="Log a result (⌘L)"
            data-testid="training-log-result"
          >
            <IconPlus aria-hidden="true" /> Log a result
          </Button>
        )}
      </div>
      <TabsContent value="overview">
        <TrainingOverview movementState={movementState} registry={registry} />
      </TabsContent>
      <TabsContent value="records">
        <RecordsTab movementState={movementState} registry={registry} />
      </TabsContent>
    </Tabs>
  );
}
